// import Calendar from './calendar/reducer';
// import Box from './box/reducer';
// import Notes from './notes/reducer';
// import Todos from './todos/reducer';
// import Contacts from './contacts/reducer';
// import DynamicChartComponent from './dynamicEchart/reducer';
// import ThemeSwitcher from './themeSwitcher/reducer';
// import YoutubeSearch from './youtubeSearch/reducers';
import Auth from './auth/reducer';
import App from './app/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import ItunesSearch from './itunesSearch/reducer';
import SearchAds from './searchads/reducer';
import { combineForms } from 'react-redux-form';
import { reducer as reduxFormReducer } from 'redux-form/immutable';
import { Map } from 'immutable';

const initialCampaignState = {
  
  currency: 'USD',
  weeklyBudget: '1.02',
  budgetSplit: [
    {key: 'AU', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'CA', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'CH', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'GB', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'MX', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'NZ', value: 10/7, percentage: 10/7/10*100, display: true, selected: true},
    {key: 'US', value: 10/7, percentage: 10/7/10*100, display: true, selected: true}
  ],
  depositAmount: 10,
  // adminFee: 0.5,  // No admin fee is charged
  discount: 0,
  maxCPA: '2',
  maxAmountForKeyword: '1.1',
  range: [20, 40, 60, 80],
  boostedKeywords: [],
  negativeKeywords: []
};


const campaign = new Map({
    currency: 'USD',
    isEvenlySplit: true,
    budgetSplit: [
      {key: 'AU', value: 10/7, display:true, selected: true},
      {key: 'CA', value: 10/7, display:true, selected: true},
      {key: 'CH', value: 10/7, display:true, selected: true},
      {key: 'GB', value: 10/7, display:true, selected: true},
      {key: 'MX', value: 10/7, display:true, selected: true},
      {key: 'NZ', value: 10/7, display:true, selected: true},
      {key: 'US', value: 10/7, display:true, selected: true}
    ],
    depositAmount: 10,
    maxCPA: 2,
    maxAmountForKeyword: 1.1,
    positiveKeywords: [],
    negativeKeywords: []
});

//TODO should move to campaagin form folder inside reducer folder
function campaignReducer(state = campaign, action) {
  switch(action.type) {
    case 'ADD_CAMPAIGN':
      console.log('ADD_CAMPAIGN',state, action)

      return state;
    case 'UPDATE_STOREFRONTS':
      console.log('UPDATE_STOREFRONTS',state,action, state.get('budgetSplit'))

      // const budgetSplit = state.get('budgetSplit');
      const budgetSplit = action.value.map(countryCode =>  {
        return {
          key: countryCode,
          value: 0,
          display: true,
          selected: true
        } 

      });
      console.log('UPDATE_STOREFRONTS',budgetSplit)

      let newBudgetSplit = budgetSplit.map(budgetItem=> {
        if (action.value.indexOf(budgetItem.key) > -1) {
          budgetItem.display = true;
          budgetItem.selected = true;
        } else {
          budgetItem.display = false;
          budgetItem.selected = false;
          budgetItem.value = 0;
        }
        return budgetItem;
      });

      if(state.get('isEvenlySplit')) {
        let storefrontCount = newBudgetSplit.filter(b=>(b.selected)).length;
        newBudgetSplit = newBudgetSplit.map(b=> {
          if (b.selected) {
            let newAmount = +parseFloat(state.get('depositAmount') / storefrontCount).toFixed(2);
            b.value = newAmount;
          }
          return b;
        });

      } else {
        let totalBudget = newBudgetSplit.filter(b=>(b.selected)).reduce((pv,cv)=>(pv + cv.value) , 0);
        newBudgetSplit = newBudgetSplit.map(b=> {
          if (b.selected) {
            let newAmount = +parseFloat(b.value / totalBudget * state.get('depositAmount')).toFixed(2); 
            b.value =  newAmount;
          }
          return b;
        });
      }
      return state.set('budgetSplit', newBudgetSplit);
    default:
      return state;
  }
}

export default {

  Auth,
  App,
  LanguageSwitcher,
  ItunesSearch ,
    // ThemeSwitcher,
  // Calendar,
  // Box,
  // Notes,
  // Todos,
  // Contacts,
  // DynamicChartComponent,
  // YoutubeSearch,
  search: SearchAds,
  form: reduxFormReducer,
  deep: combineForms({
    campaign: initialCampaignState,
    //updateCampaign
    auth0SignUp: {},
    auth0SignIn: {} 
  }, 'deep'),
  campaign: campaignReducer
  // campaign: {
  //   currency: 'USD',
  //   weeklyBudget: '1.02',
  //   budgetSplit: [
  //     {key: 'AU', value: 10/7, selected: true},
  //     {key: 'CA', value: 10/7, selected: true},
  //     {key: 'CH', value: 10/7, selected: true},
  //     {key: 'GB', value: 10/7, selected: true},
  //     {key: 'MX', value: 10/7, selected: true},
  //     {key: 'NZ', value: 10/7, selected: true},
  //     {key: 'US', value: 10/7, selected: true}
  //   ],
  //   depositAmount: 10,
  //   discount: 0,
  //   maxCPA: '2',
  //   maxAmountForKeyword: '1.1',
  //   range: [20, 40, 60, 80],
  //   boostedKeywords: [],
  //   negativeKeywords: []
  // }
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js